import React from 'react';
import {ReactComponent as ToReleaseIcon} from '../../../../assets/icons/fire-user.svg';
import AvatarSpectator from '../../../../assets/images/avatars/avatar-spectator.png';
import AvatarUser from '../../../../assets/images/avatars/avatar-users.png';
import {ReactComponent as UseAddIcon} from '../../../../assets/icons/user-add.svg';
import {ReactComponent as ToDeleteIcon} from '../../../../assets/icons/delete.svg';
import {ReactComponent as SettingsIcon} from '../../../../assets/images/profile/Menu/project3.svg';

import './Customers.scss';
import {IconButtonMUI} from '../../../../shared';
import {useTranslation} from 'react-i18next';
import {useSelector} from "react-redux";

const Customers = ({
                       firstName,
                       position,
                       isActive,
                       avatar,
                       id,
                       handleId,
                       onBlock,
                       roleName,
                       onReturn,
                       onRemoveClient,
                       editPermission,
                       removePermission = false,
                       phone,
                       email,
                       onEditUser,
                       editPerson,
                       blockCustomerPermission = false,
                       returnCustomerPermission = false
                   }) => {
    const profileMe = useSelector((state) => state.profile.profileMe);

    const isMe = profileMe?.id === id;
    const {t} = useTranslation();
    return (
        <div className='projects-customers' key={id}>
            <div className='projects-customers__info'>
                <div className='projects-customers__info-avatar'>
                    {avatar ? (
                        <img className='avatar-image' src={avatar} alt={firstName}/>
                    ) : position === 'spectator' ? (
                        <img className='avatar-image' src={AvatarSpectator} alt={firstName}/>
                    ) : (
                        <img className='avatar-image' src={AvatarUser} alt={firstName}/>
                    )}

                    {isActive === true ? <div className='status active'/> : <div className='status'/>}
                </div>
                <div className='projects-customers__info-user'>
                    <div className='projects-customers__info-name' onClick={handleId}>
                        {firstName}
                    </div>
                    <div className='projects-customers__info-role'>{roleName}</div>
                </div>
            </div>

            <div className='projects-employees__details-btn-wrapper'>
                {onRemoveClient && (removePermission) && !isMe && (
                    <div className='projects-employees__details-btn' onClick={() => onRemoveClient(id)}>
                        <IconButtonMUI color={'inherit'} title={t('CustomerInner.delete')}>
                            <ToDeleteIcon/>
                        </IconButtonMUI>
                    </div>
                )}
                {isActive && blockCustomerPermission && !isMe && (
                    <div className='projects-customers__btn' onClick={() => onBlock(id)}>
                        <IconButtonMUI color={'inherit'} title={t('CustomerInner.block')}>
                            <ToReleaseIcon/>
                        </IconButtonMUI>
                    </div>
                )}
                {!isActive && returnCustomerPermission && !isMe && (
                    <div className='projects-customers__btn' onClick={() => onReturn(id)}>
                        <IconButtonMUI color={'inherit'} title={t('CustomerInner.unblock')}>
                            <UseAddIcon/>
                        </IconButtonMUI>
                    </div>
                )}
                {editPerson && (
                    <div
                        className='projects-customers__btn'
                        onClick={() =>
                            onEditUser({
                                id: id,
                                name: firstName,
                                avatar: avatar,
                                email: email,
                                phone: phone
                            })
                        }
                    >
                        <IconButtonMUI color={'inherit'} title={t('dictionaries.edit')}>
                            <SettingsIcon/>
                        </IconButtonMUI>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Customers;
